import { useState } from 'react';
import axios from "axios";
import { operationLogisticLogin, clientLogin } from '../Services/authService.js'
import { useNavigate } from "react-router-dom";
import Modal from "../AlertModal/Modal.jsx";


function LoginLogistics() {
    const [showPassword, setShowPassword] = useState(false);
    const [toggleOn, setToggleOn] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);
    // const handleToggle = () => setToggleOn(!toggleOn);

    const [emailOrMobile, setEmailOrMobile] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const navigate = useNavigate();


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});


    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: "Login successfully.",
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    const handleToggle = () => {
        setToggleOn(!toggleOn);
        setPassword("");
        setEmailOrMobile("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg("");
        setLoading(true);

        const payload = toggleOn
            ? { mobile: emailOrMobile, password } // client
            : { email: emailOrMobile, password }; // operation/logistic

        try {
            const response = toggleOn
                ? await clientLogin(payload)
                : await operationLogisticLogin(payload);

            console.log("Login successful:", response);
            // return
            if (response.status == 1) {
                localStorage.setItem("token", response?.access_token);
                localStorage.setItem("user", JSON.stringify(response.user));

                showSuccess();

                if (response?.user.role === "OPERATION") {
                    navigate("/operation-dashboard");
                } else if (response?.user.role === "LOGISTIC") {
                    navigate("/logistics-dashboard");
                } else {
                    navigate("/client-dashboard");
                }
            } else {
                showError('Sorry', response.message)
            }
            
            // window.location.href = "/dashboard";
        } catch (error) {
            console.error("Login failed:", error);
            showError('Error!', error);
            setErrorMsg(error.message || "Login failed. Please try again.");
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="login-container">
                <div className="logbox">
                    <h4>Login</h4>
                    <form onSubmit={handleSubmit}>
                        {!toggleOn && (
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    className="form-control"
                                    value={emailOrMobile}
                                    onChange={(e) => setEmailOrMobile(e.target.value)}
                                    required
                                />
                            </div>
                        )}

                        {toggleOn && (
                            <div className="form-group">
                                <label>Mobile No</label>
                                <input
                                    type="text"
                                    placeholder="Enter mobile number"
                                    className="form-control"
                                    value={emailOrMobile}
                                    onChange={(e) => setEmailOrMobile(e.target.value)}
                                    required
                                />
                            </div>
                        )}

                        {/* Password Field */}
                        <div className="form-group password-group">
                            <label>Password</label>
                            <div className="password-wrapper position-relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter your password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <span
                                    className="toggle-password position-absolute end-0 top-50 translate-middle-y me-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={togglePassword}
                                >
                                    {showPassword ? (
                                        <i className="fa-regular fa-eye-slash"></i>
                                    ) : (
                                        <i className="fa-solid fa-eye"></i>
                                    )}
                                </span>
                            </div>
                        </div>

                        {/* Toggle Switch */}
                        <div className="form-group d-flex align-items-center mb-3">
                            <div
                                onClick={() => {
                                    handleToggle();
                                    setPassword('');
                                    setEmailOrMobile('');
                                }}
                                style={{
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    background: toggleOn ? "#00a651" : "#ccc",
                                    borderRadius: "30px",
                                    width: "60px",
                                    height: "28px",
                                    position: "relative",
                                    transition: "all 0.3s ease",
                                }}
                            >
                                <div
                                    style={{
                                        position: "absolute",
                                        left: toggleOn ? "32px" : "4px",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        background: "#fff",
                                        transition: "left 0.3s ease",
                                    }}
                                ></div>
                            </div>
                            <span className="ms-2">
                                {toggleOn ? "Client" : "Operation/Logistics"}
                            </span>
                        </div>

                        {errorMsg && (
                            <p className="text-danger text-center mb-2">{errorMsg}</p>
                        )}

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={loading}
                            >
                                {loading ? "Logging in..." : "Login"}
                            </button>
                        </div>
                    </form>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    title={modalConfig.title}
                    message={modalConfig.message}
                    type={modalConfig.type}
                />
            </div>

        </>
    )
}

export default LoginLogistics